import React from "react"

import { DateRangePicker } from "~/ui-rtk/components/ui/controls/DateRangePicker/DateRangePicker"
import type { TableVisualizationColumnFilter } from "~/ui-rtk/constants/table-visualization-types"
import { type TFilterColumnConfig } from "../types"

type DateFilterProps = {
  column: TFilterColumnConfig
  tableFilter?: TableVisualizationColumnFilter | null
  onChange: (
    key: string,
    value: { startDate?: Date | null; endDate?: Date | null },
  ) => void
}

const DateFilter: React.FC<DateFilterProps> = ({
  tableFilter,
  column: columnDef,
  onChange,
}) => {
  const defaultValue = tableFilter?.value as {
    startDate?: Date | null | string
    endDate?: Date | null | string
  }

  // Convert string dates to Date objects if needed
  const getDateValue = (dateValue?: Date | null | string): Date | null => {
    if (!dateValue) return null
    if (dateValue instanceof Date) return dateValue

    const parsed = new Date(dateValue)
    return isNaN(parsed.getTime()) ? null : parsed
  }

  const handleDateRangeChange = (dates: {
    start: Date
    end: Date
    compareStart?: Date | null
    compareEnd?: Date | null
  }) => {
    // Convert the DateRangePicker format to the expected filter format
    const filterValue = {
      startDate: dates.start,
      endDate: dates.end,
    }
    onChange(columnDef.key, filterValue)
  }

  return (
    <div className="space-y-3">
      <label className="ml-1 font-semibold">Date Range</label>
      <DateRangePicker
        start={getDateValue(defaultValue?.startDate)}
        end={getDateValue(defaultValue?.endDate)}
        comparisonEnabled={false}
        onChange={handleDateRangeChange}
      />
    </div>
  )
}

export default DateFilter
